import * as Clipboard from "expo-clipboard";
import * as Linking from "expo-linking";
import { getLocales } from "expo-localization";
import { Platform } from "react-native";
import { Button, useTheme } from "react-native-paper";

import { TrackingStatusAction } from "../types";

type Props = {
  action: TrackingStatusAction;
};

export default function ActionButton({ action }: Props) {
  const { colors } = useTheme();

  async function onPress() {
    switch (action.type) {
      case "send_whatsapp": {
        openUrl(
          `https://wa.me/${action.params.whatsapp}?text=${action.params.prefilled_text}`
        );
        break;
      }
      case "copy": {
        Clipboard.setStringAsync(action.params.text);
        break;
      }
      case "visit_url": {
        openUrl(action.params.url);
        break;
      }
      case "fill_validation": {
        const locale = getLocale();
        openUrl(action.params.consumer_validation_urls[locale]);
        break;
      }
    }
  }

  function getStyles() {
    if (action.primary) {
      return {
        buttonColor: colors.secondaryContainer,
        textColor: colors.onSecondaryContainer,
      };
    } else {
      return {
        buttonColor: "transparent",
        textColor: colors.secondary,
      };
    }
  }

  const { buttonColor, textColor } = getStyles();

  return (
    <Button buttonColor={buttonColor} textColor={textColor} onPress={onPress}>
      {action.label}
    </Button>
  );
}

function openUrl(url: string) {
  if (Platform.OS === "web") {
    window.open(url, "_blank");
  } else {
    Linking.openURL(url);
  }
}

function getLocale() {
  const deviceLanguage = getLocales();
  const locale = deviceLanguage[0].languageCode;

  if (locale === "en") {
    return "en";
  } else {
    return "es";
  }
}
